<template>
  <div class="d-flex-column justify-start align-start gap-40">
    <MmoPackDetail class="small_bg_2" v-if="!$isMobile() && !$isTablet()" />

    <RatingPicker :defaul-value="1800" />

    <div
      class="d-flex-column justify-start align-start gap-24"
      v-if="!$isMobile() && !$isTablet()"
    >
      <!-- <template v-for="key in keys">
        <div
          class="pack_text_detail"
          v-html="getGamePack?.pack_description_detail[key]"
        ></div>
      </template> -->
    </div>
  </div>
</template>

<script setup>
import ServerPicker from "./pickers/ServerPicker.vue";
import RatingPicker from "./pickers/RatingPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import MmoPackDetail from "./pickers/MmoPackDetail.vue";
import { computed, watch, onMounted } from "vue";


const checkoutStore = useCheckoutStore();
const { getGamePack, getGame } = useGameStore();

const disabledIds = computed(() => {
  if (checkoutStore.getDetails?.desiredRating > 1800) {
    let options = [];
    const selfPlayOption = getGamePack?.pack_options?.find(
      (option) => option.const_title === "self_play"
    );
    if (selfPlayOption) {
      options.push(selfPlayOption.id);
    }
    return options;
  }

  return [];
});

const clickSingleOption = (option) => {
  if (checkoutStore.getPackOptions?.includes(option.id)) {
    return;
  }
  checkoutStore.removePackOption({
    optionIds: option?.rules?.disable || [],
  });
  checkoutStore.setPackOptions({
    options: [...checkoutStore.getPackOptions, option.id],
  });
};

const selectSelfPlay = () => {
  const selfPlayOption = getGamePack?.pack_options?.find(
    (option) => option.const_title === "self_play"
  );
  if (selfPlayOption) {
    clickSingleOption(selfPlayOption);
  }
};

const selectPiloted = () => {
  const pilotedOption = getGamePack?.pack_options?.find(
    (option) => option.const_title === "account_sharing"
  );
  if (pilotedOption) {
    clickSingleOption(pilotedOption);
  }
};

watch(
  () => checkoutStore.getDetails,
  (newVal) => {
    if (newVal.desiredRating > 1800) {
      selectPiloted();
    }
  },
  { deep: true }
);

const handleDetails = () => {
  const multiglad = getGamePack.pack_options?.find(
    (op) => op.const_title === "multiglad_player"
  );
  const standard = getGamePack?.pack_options?.find(
    (op) => op.const_title === "standard"
  );

  checkoutStore.clearCheckout();
  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentRating: 0,
    desiredRating: 1800,
  });

  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });

  const firstExtraOption = getGamePack.pack_extra_options[0];
  if (multiglad) {
    checkoutStore.setPackOptions({
      options: [multiglad.id],
    });
  }
  if (standard) {
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, standard.id],
    });
  }
  // checkoutStore.setPackExtraOptions({
  //   mode: firstExtraOption?.id,
  // });
  selectPiloted();
};

handleDetails();

onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
